import {ErrorTracker} from "../../../../error.tracker";

export interface IFormPartParameters {
    errorTracker?: ErrorTracker
    expression: string
    id?: string
    isValid?: () => boolean
    preview?: boolean
    value?: KnockoutObservable<any>
}
